<template>
  <v-dialog persistent v-model="show" width="1000">
    <v-card>
      <v-card-title>
        <span class="headline">DO乗合画面</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!canSave" @click="save" class="ml-2">保存</v-btn>
        <v-btn @click="goBack" class="ml-2">{{$t('app.buttons.back')}}</v-btn>
        <v-btn :disabled="!canRemove" @click="remove" class="ml-2">削除</v-btn>
      </v-card-actions>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs3>
            <!-- <remote-autocomplete
              :label="'DONO-枝番'"
              url="drake-sharing/dono-branch/kv"
              v-model="query.shipmentId"
            />-->

            <query-autocomplete
              clearable
              item-text="text"
              item-value="value"
              label="do枝番検索"
              url="drake-sharing/dono-branch/kv?text={term}"
              v-model="shipmentId"
            />
          </v-flex>
          <v-flex xs3>
            <v-btn :disabled="!canAddChild" @click="addDrakeSharing">添加</v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-data-table
                :headers="headers"
                :hide-actions="true"
                :items="displayFirstItem"
                :rows-per-page-items="[10]"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.forecastDeliveryDate}}</td>
                  <td>{{ props.item.departureType=='PORT'?props.item.departurePortName:props.item.departureWarehouseName }}</td>
                  <td>{{ props.item.destinationWarehouseName }}</td>
                  <td>{{props.item.deliverySupplierName}}</td>
                  <td>{{props.item.deliveryModelName}}</td>
                  <td>{{props.item.requestUnitPrice}}</td>
                  <td>{{props.item.paymentUnitPrice}}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-data-table
                :headers="amountHeaders"
                :hide-actions="true"
                :items="items"
                class="elevation-1"
                item-key="shipmentId"
                select-all
                v-model="selected"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
                  </td>
                  <td>{{ props.item.doNo+'-'+props.item.branchCode }}</td>
                  <td>{{ props.item.percent }}</td>
                  <td>{{ props.item.requestPrice }}</td>
                  <td>{{props.item.subTotal}}</td>
                  <td>{{props.item.paymentPrice}}</td>
                  <td>{{props.item.paymentSubTotal}}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    items: [],
    show: false,
    selected: [],
    shipmentId: null,
    deliveryOrders: [],
    headers: [
      { text: '配送日', value: 'deliveryDate', sortable: false },
      { text: '発地', value: 'place', sortable: false },
      { text: '着地', value: 'landing', sortable: false },
      { text: '配送業者', value: 'deliverySupplierName', sortable: false },
      { text: '搬送サービス', value: 'deliveryModelName', sortable: false },
      { text: '請求単価', value: 'requestUnitPrice', sortable: false },
      { text: '支払単価', value: 'paymentUnitPrice', sortable: false }
    ],
    amountHeaders: [
      { text: 'D/O NO', value: 'doNoBranchCode', sortable: false },
      { text: '混載占め', value: 'percent', sortable: false },
      { text: '請求金額', value: 'requestPrice', sortable: false },
      {
        text: '請求調整後金額',
        value: 'subTotal',
        sortable: false
      },
      { text: '支払金額', value: 'paymentPrice', sortable: false },
      { text: '支払調整後金額', value: 'paymentSubTotal', sortable: false }
    ]
  }),
  computed: {
    displayFirstItem() {
      if (this.items.length > 0) {
        return [this.items[0]]
      }
      return []
    },
    canAddChild() {
      return (
        this.items.length > 0 && !this.items[0].drakeGroup && this.shipmentId
      )
    },
    canSave() {
      return this.items.length > 1 && !this.items[0].drakeGroup
    },
    canRemove() {
      return (
        this.selected.length > 0 && this.selected.length < this.items.length
      )
    }
  },
  methods: {
    goBack() {
      this.items = []
      this.show = false
    },
    save() {
      this.$http
        .post(`/drake-sharing/batch`, this.items)
        .then(() => {
          this.$message('', 'success')
          this.goBack()
        })
        .catch(error => this.$catch(error))
    },
    popup(shipmentIds) {
      this.show = true
      this.loadItems(shipmentIds)
    },
    loadItems(shipmentIds) {
      this.$http
        .get(`/drake-sharing/batch?shipmentIds=${shipmentIds.join(',')}`)
        .then(res => {
          this.selected = []
          this.shipmentId = null
          this.items = res.data
          if (this.items.length >= 1 && !this.items[0].drakeGroup) {
            this.resetDrakeSharingPercentAndCost()
          }
        })
        .catch(error => this.$catch(error))
    },
    addDrakeSharing() {
      if (this.shipmentId) {
        this.loadItems([...this.items.map(i => i.shipmentId), this.shipmentId])
      }
    },
    remove() {
      this.loadItems(
        this.items
          .filter(i => !this.selected.includes(i))
          .map(i => i.shipmentId)
      )
    },
    resetDrakeSharingPercentAndCost() {
      let radio = 1000000
      const totalCw = this.items.reduce((t, c) => t + c.cw, 0)
      this.items.forEach(i => {
        i.totalCw = totalCw
      })
      let sumPercent = 0
      let sumRequestPrice = 0
      let sumPaymentPrice = 0
      for (let i = 0; i < this.items.length - 1; i++) {
        sumPercent += this.items[i].percent =
          Math.floor((this.items[i].cw / this.items[i].totalCw) * radio) / radio
        sumRequestPrice += this.items[i].subTotal = this.items[
          i
        ].requestPrice = Math.round(
          this.items[i].requestUnitPrice * this.items[i].percent
        )
        sumPaymentPrice += this.items[i].paymentSubTotal = this.items[
          i
        ].paymentPrice = Math.round(
          this.items[i].paymentUnitPrice * this.items[i].percent
        )
      }
      this.items[this.items.length - 1].percent =
        Math.round((1 - sumPercent) * radio) / radio
      this.items[this.items.length - 1].subTotal = this.items[
        this.items.length - 1
      ].requestPrice =
        this.items[this.items.length - 1].requestUnitPrice - sumRequestPrice
      this.items[this.items.length - 1].paymentSubTotal = this.items[
        this.items.length - 1
      ].paymentPrice =
        this.items[this.items.length - 1].paymentUnitPrice - sumPaymentPrice
    }
  }
}
</script>